module.exports = __webpack_public_path__ + "media/images/static/offer/lp_s03-1_s-8de182f911c4604dac66b0555676b3ee.png";